@if (config(); as config) {
  <div
    class="login-screen {{ config?.displayInputsLabel ? 'display' : 'hide' }}-inputs-label"
    [style.background-image]="'url(' + config?.backgroundImageUrl + ')'">
    <div class="login-wrapper">
      <div class="content-wrapper row">
        <div class="content-left col-12 col-md-5">
          <div [style.background-image]="'url(' + config?.logoImageUrl + ')'" class="logo" data-test="logo"></div>
        </div>
        <div class="content-right col-12 col-md-7">
          <!-- View/routes wrapper-->
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </div>
}
